import React, { useCallback, useRef } from 'react';
import { View, TextInput } from 'react-native';
import getSymbolFromCurrency from 'currency-symbol-map';
import { rem, SettingsItem, SettingsItemRightContent } from 'design-system';
import FlatListItemCard from 'design-system/FlatListItemCard';
import Text, { styles as textStyles } from 'design-system/Text';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { CustomSplitType } from 'utils/types/navigation';
import createStyleSheets from 'utils/createStyleSheets';
import { MoneyTextInput } from 'utils/packages/moneyInput';
import { focus } from 'hooks/useAutoFocusInput';
import { isWeb } from '../../../constants';
import { GroupUserAvatar } from './GroupExpenseCRow';
const MAX_LENGTH = 10;
export const CustomSplitRow = ({ index, itemsLength, item, selectedType, percentageSplit, shareSplit, amountSplit, onChangeSplit, currency, maxAmount, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const inputRef = useRef(null);
    const onPress = useCallback(() => focus(inputRef), []);
    return (<FlatListItemCard index={index} itemsLength={itemsLength} style={styles.card}>
      <SettingsItem renderIcon={() => <GroupUserAvatar groupUser={item}/>} onPress={onPress} title={`${item.firstName} ${item.lastName}`} description={item.handle ? `@${item.handle}` : undefined} key={item.id}>
        <SettingsItemRightContent style={styles.rightContent}>
          {selectedType === CustomSplitType.PERCENTAGE && (<View style={styles.row}>
              <MoneyTextInput value={percentageSplit[item.id]} ref={inputRef} returnKeyType="done" style={styles.textInput} onChangeText={(_formatted, extracted = '') => onChangeSplit(item.id, extracted)} groupingSeparator="" maximumIntegerDigits={3} minValue={0} maxValue={100} autoComplete="off" underlineColorAndroid="transparent" placeholderTextColor={colors.text.secondary}/>
              <Text Text-16 Secondary>
                %
              </Text>
            </View>)}
          {selectedType === CustomSplitType.SHARE && (<TextInput value={shareSplit[item.id]} ref={inputRef} returnKeyType="done" keyboardType="numeric" style={styles.textInput} onChangeText={(raw) => onChangeSplit(item.id, raw ?? '0')} maxLength={6} underlineColorAndroid="transparent" selectionColor={colors.text.selection} placeholderTextColor={colors.text.secondary} allowFontScaling={false}/>)}
          {selectedType === CustomSplitType.AMOUNT && (<MoneyTextInput value={amountSplit[item.id]} ref={inputRef} returnKeyType="done" style={styles.textInput} onChangeText={(_formatted, extracted = '') => onChangeSplit(item.id, extracted)} maximumIntegerDigits={Math.trunc(maxAmount).toString().length} maxValue={maxAmount} underlineColorAndroid="transparent" selectionColor={colors.text.selection} placeholderTextColor={colors.text.placeholder} allowFontScaling={false} onFocus={() => inputRef.current?.setSelection?.(MAX_LENGTH, MAX_LENGTH)} prefix={getSymbolFromCurrency(currency)}/>)}
        </SettingsItemRightContent>
      </SettingsItem>
    </FlatListItemCard>);
};
const styleSet = createStyleSheets((colors) => ({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(8),
    },
    card: {
        backgroundColor: colors.cards.onDark,
    },
    textInput: {
        ...textStyles.Numbers_20,
        color: colors.text.primary,
        // a browser input without a width takes about 20 characters' room
        ...(isWeb && { width: rem(96), textAlign: 'right' }),
    },
    rightContent: {
        minHeight: rem(52),
    },
}));
